import React from 'react'
import { Outlet } from 'react-router-dom'
export default function Manage() {
  return (
    <div className='manage'>
      <Outlet/>
    </div>
  )
}
